module.exports = __webpack_public_path__ + "static/media/Rectangle 9.a946b399.png";